/* eslint-env browser */

import * as React from 'react'
import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')
const classNames = require('classnames')
const axios = require('axios')

const FullCatch = require('../Catches/FullCatch')

class ArrayModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: 0,
      loadingById: {},
      valuesById: {},
    }
    this.selectItem = this.selectItem.bind(this)
    this.onKeyPressEvent = this.onKeyPressEvent.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.goNext = this.goNext.bind(this)
  }

  componentDidMount() {
    if (document) {
      document.body.addEventListener('keydown', this.onKeyPressEvent)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { isActive } = this.props
    if (nextProps.isActive && !isActive) {
      this.selectItem(nextProps.initialIndex || 0, nextProps)
    }
  }

  componentWillUnmount() {
    if (document) {
      document.body.removeEventListener('keydown', this.onKeyPressEvent)
    }
  }

  onKeyPressEvent(e) {
    const { isActive, onHide } = this.props

    if (isActive && ['Escape', 'ArrowLeft', 'Left', 'ArrowRight', 'Right'].indexOf(e.key) > -1) {
      e.preventDefault()
      e.stopPropagation()
      switch (e.key) {
        case 'Escape':
          onHide()
          break
        case 'ArrowLeft':
        case 'Left':
          this.goPrev()
          break
        case 'ArrowRight':
        case 'Right':
          this.goNext()
          break
        default:
          break
      }
    }
  }

  goPrev() {
    const { selected } = this.state
    this.selectItem(selected - 1)
  }

  goNext() {
    const { selected } = this.state
    this.selectItem(selected + 1)
  }

  selectItem(idx, props = this.props) {
    const { ids, type } = props
    const { loadingById } = this.state

    if (idx < 0 || idx > ids.length - 1) {
      return
    }

    const id = ids[idx]
    this.setState(prevState => ({
      selected: idx,
      loadingById: {
        ...prevState.loadingById,
        [id]: true,
      },
    }))

    if (loadingById[id] !== true) {
      axios.get(`/api/renderProps/${type}/${id}`).then(response => {
        this.setState(prevState => ({
          loadingById: {
            ...prevState.loadingById,
            [id]: false,
          },
          valuesById: {
            ...prevState.valuesById,
            [id]: response.data,
          },
        }))
      })
    }
  }

  render() {
    const { isActive, onHide, type, ids, locale, isLoggedIn, userSettings, host } = this.props
    const { selected, valuesById } = this.state

    let component = (
      <div className="has-padding-small" style={{ height: '100%', background: 'white' }}>
        <div className="columns">
          <div className="column is-12">
            <div className="loader is-size-1 is-primary is-self-centered" />
          </div>
        </div>
      </div>
    )
    const id = ids[selected]
    if (valuesById[id]) {
      switch (type) {
        case 'fishCatches':
          component = (
            <div className="has-padding-small" style={{ height: '100%' }}>
              <FullCatch
                locale={locale}
                isLoggedIn={isLoggedIn}
                userSettings={userSettings}
                host={host}
                {...valuesById[id]}
              />
            </div>
          )
          break
        default:
          break
      }
    }

    return (
      <div className={classNames('modal', { 'is-active': isActive })}>
        <div className="modal-background" onClick={onHide} />
        <div
          className="modal-content"
          style={{
            position: 'absolute',
            top: 20,
            left: 60,
            right: 60,
            bottom: 20,
            width: 'auto',
          }}
        >
          <div style={{ position: 'relative', height: '100%' }}>{component}</div>
        </div>
        <button type="button" className="modal-close is-large" aria-label="close" onClick={onHide} />
        <button
          type="button"
          className={classNames('modal-close is-large is-previous', { 'is-hidden': selected === 0 })}
          aria-label="previous"
          onClick={this.goPrev}
        />
        <button
          type="button"
          className={classNames('modal-close is-large is-next', { 'is-hidden': selected === ids.length - 1 })}
          aria-label="next"
          onClick={this.goNext}
        />
      </div>
    )
  }
}

ArrayModal.propTypes = {
  translate: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  type: PropTypes.string,
  ids: PropTypes.array,
  isActive: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  initialIndex: PropTypes.number,
  isLoggedIn: PropTypes.bool,
  userSettings: PropTypes.object,
  host: PropTypes.string.isRequired,
}

ArrayModal.defaultProps = {
  isActive: false,
  ids: [],
  initialIndex: 0,
  isLoggedIn: false,
  type: 'null',
  userSettings: {},
}

module.exports = withTranslator(ArrayModal)
